import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';

const URL = API_BASE_URL.DESCRICAO_ENTREGA;

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getDescricao(idEntidade) {
  const resp = await axios.get(`${URL}/${idEntidade}`, { headers: authHeaders() });
  return resp.data && Array.isArray(resp.data) && resp.data.length ? resp.data[0] : null;
}

export async function getList(idEntidade) {
  const resp = await axios.get(`${URL}/${idEntidade}`, { headers: authHeaders() });
  return resp.data || [];
}

export async function save(dto) {
  const resp = await axios.post(`${URL}/save`, dto, { headers: authHeaders() });
  return resp.data;
}

export async function update(dto) {
  const resp = await axios.put(`${URL}/update`, dto, { headers: authHeaders() });
  return resp.data;
}

export async function deleteDescricao(idEntidade, id) {
  const resp = await axios.delete(`${URL}/delete/${idEntidade}/${id}`, { headers: authHeaders() });
  return resp.data;
}

export default { getDescricao, getList, save, update, deleteDescricao };
